<div class="generalPage" aria-label="help-seccontent" role="main">
  <div class="pr-22 content-container pb-0 print-all-content">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont" role="heading">{{sec_heading}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" (click)="openlinkbyId($event)" [innerHTML]="sec_desc"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading mb-1" role="heading">{{sec_para1heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="sec_para1body"></p>
  </div>
</div>

